/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/anchor-has-content */
import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import 'swiper/swiper-bundle.min.css';
import 'swiper/swiper.min.css';
import $ from 'jquery';
import TagManager from 'react-gtm-module';

function Caption04() {
	let location = useLocation();
	const tagManagerArgs = {
		gtmId: 'GTM-NDBLPCX'
	}
	TagManager.initialize(tagManagerArgs);
	useEffect(() => {
		//$(".btn_popup").off('click');
		//$(".btn_close").off('click');
		$(".btn_popup").on('click', function () {
			$(".popup").hide();
			var href = "#" + $(this).attr('id');
			$(href).show();
		})
		$(".btn_close").on('click', function () {
			$(".popup").hide();
		});
	}, [location])
	return (
		<>
			<div className="popup" id="cb_pop28">
				<div className="pagesize">
					<div className="popup_box pb_big caption_txt">
						<a className="btn_close"></a>
						<div className="popup_txt">
							<div className="cb_type">
								<div className="cb_tag">企業應用</div>
								<h4 className="cb_28">PickMeUp接送助手</h4>
								<p>PickMeUp接送助手結合i寶貝智慧音箱，可輕鬆透過音箱推播家長接送資訊，讓下課時間接送孩子輕鬆、安全更便利！</p>
							</div>
							<div className="cb_tit">使用範例</div>
							<div className="cb_dialog">
								<ul>
									<li><p><span>提供家長資訊推播(燈燈燈、大樹班、王小明)</span></p></li>
								</ul>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div className="content_inpage">
				<div className="pagesize">
					<ul className="bread">
						<li><a href="/">首頁</a></li>
						<li><a href="/container/caption">服務說明</a></li>
					</ul>
					<div className="tab_con">
						<div className="tab_box active">
							<h2 className="tit_main">服務說明 - 企業應用</h2>
							<div className="content_box caption_box">
								<div className="cb_item flex_set">
									<div className="cb_box flex_box"><a id="cb_pop28" className="btn_popup cb_28">PickMeUp<br />接送助手</a></div>
								</div>
								<div className="cb_dialog">
									<ul>
										<li className="flex_set cb_28"><p className="flex_box"><span>(提供資訊推播)<br />大樹班的王小明，請到門口準備回家。</span></p></li>
									</ul>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</>
	)
}

export default Caption04;